import type { Editor, EditorStateSnapshot } from '@tiptap/react';

export function menuBarStateSelector(ctx: EditorStateSnapshot<Editor>) {
  return {
    isBold: ctx.editor.isActive('bold') ?? false,
    canBold: (ctx.editor.can().chain().toggleBold && ctx.editor.can().chain().toggleBold().run()) ?? false,
    isItalic: ctx.editor.isActive('italic') ?? false,
    canItalic: (ctx.editor.can().chain().toggleItalic && ctx.editor.can().chain().toggleItalic().run()) ?? false,
    isUnderline: ctx.editor.isActive('underline') ?? false,
    canUnderline:
      (ctx.editor.can().chain().toggleUnderline && ctx.editor.can().chain().toggleUnderline().run()) ?? false,
    isStrike: ctx.editor.isActive('strike') ?? false,
    canStrike: (ctx.editor.can().chain().toggleStrike && ctx.editor.can().chain().toggleStrike().run()) ?? false,
    canUndo: (ctx.editor.can().chain().undo && ctx.editor.can().chain().undo()) ?? false,
    canRedo: (ctx.editor.can().chain().redo && ctx.editor.can().chain().redo()) ?? false,
    isCode: ctx.editor.isActive('code') ?? false,
    canCode: (ctx.editor.can().chain().toggleCode && ctx.editor.can().chain().toggleCode().run()) ?? false,
    isBlockquote: ctx.editor.isActive('blockquote') ?? false,
    canBlockquote:
      (ctx.editor.can().chain().toggleBlockquote && ctx.editor.can().chain().toggleBlockquote().run()) ?? false,
  };
}

export type MenuBarState = ReturnType<typeof menuBarStateSelector>;
